import { Platform } from "react-native";
import PushNotification from "react-native-push-notification";
import PushNotificationIOS from "@react-native-community/push-notification-ios";
import getRandomIntInclusive from "@microdoing/shared/utils/getRandomIntInclusive";
import moment, { Moment } from "moment";
import { store } from "../store";
import i18n from "../../i18n";
import getLastNotifications from "./getLastNotifications";
import getFirstNotifications from "./getFirstNotifications";
import getRandomNotifications from "./getRandomNotifications";
import {
  getFirstReminderTime,
  getSecondReminderTime,
  getNumberOfReminders,
  getReminderDays,
  getThirdReminderTime,
} from "../profileSettings/selectors";

export interface ScheduleNotifType {
  date: Date;
  notificationId: Number; // id has to be numerous
  title: String;
  body: String;
}

export const scheduleNotif = async ({
  date,
  notificationId,
  title = "😊 ta best practice du jour vient d'arriver !",
  body = "Découvre ton défi !",
}: ScheduleNotifType) => {
  try {
    PushNotification.localNotificationSchedule({
      vibration: 300,
      priority: "hight",
      visibility: "public",
      importance: "hight",
      color: "#16193F",
      title,
      message: body,
      userInfo: {},
      date,
      allowWhileIdle: true,
      id: `${notificationId}`, // local notification schedule function take only string of digits
      number: 1,
      ignoreInForeground: false,
    });
  } catch (e) {
    console.log("ERRORR NOTIF");
    console.log(e);
  }
};

const setNotifTimeValue = ({ notifTime, isoWeekDay, week = 0 }) => {
  const result = moment()
    .isoWeekday(isoWeekDay)
    .add(week, "week")
    .hour(notifTime.hour)
    .minute(notifTime.minute)
    .toDate();
  return result;
};

const monthlyNotif = ({ notifTime, firstName }) => {
  // schedule notifs for the followings weeks - they are reset if an action is validated
  const nextMonday = setNotifTimeValue({ notifTime, isoWeekDay: 1, week: 2 });
  const nextThursday = setNotifTimeValue({ notifTime, isoWeekDay: 4, week: 2 });
  const nextMonday2 = setNotifTimeValue({ notifTime, isoWeekDay: 1, week: 3 });
  const nextThursday2 = setNotifTimeValue({
    notifTime,
    isoWeekDay: 4,
    week: 3,
  });
  const nextMonday3 = setNotifTimeValue({ notifTime, isoWeekDay: 1, week: 3 });
  const nextThursday3 = setNotifTimeValue({
    notifTime,
    isoWeekDay: 4,
    week: 4,
  });

  // Monthly goal notif format : 100-1

  scheduleNotif({
    date: nextMonday,
    notificationId: 1001,
    title: i18n.t("monthly-goals-notif-title-1", { firstName }),
    body: i18n.t("monthly-goals-notif-message-1", { firstName }),
  });

  scheduleNotif({
    date: nextThursday,
    notificationId: 1002,
    title: i18n.t("monthly-goals-notif-title-2", { firstName }),
    body: i18n.t("monthly-goals-notif-message-2", { firstName }),
  });

  scheduleNotif({
    date: nextMonday2,
    notificationId: 1003,
    title: i18n.t("monthly-goals-notif-title-3", { firstName }),
    body: i18n.t("monthly-goals-notif-message-3", {
      firstName,
    }),
  });

  scheduleNotif({
    date: nextThursday2,
    notificationId: 1004,
    title: i18n.t("monthly-goals-notif-title-4", { firstName }),
    body: i18n.t("monthly-goals-notif-message-4", {
      firstName,
    }),
  });

  scheduleNotif({
    date: nextMonday3,
    notificationId: 1005,
    title: i18n.t("monthly-goals-notif-title-5", { firstName }),
    body: i18n.t("monthly-goals-notif-message-5", {
      firstName,
    }),
  });

  scheduleNotif({
    date: nextThursday3,
    notificationId: 1006,
    title: i18n.t("monthly-goals-notif-title-6", { firstName }),
    body: i18n.t("monthly-goals-notif-message-6", {
      firstName,
    }),
  });
};

export const scheduleGoalNotif = async () => {
  const state = await store.getState();
  const firstReminderTime = getFirstReminderTime(state);
  const secondReminderTime = getSecondReminderTime(state);
  const thirdReminderTime = getThirdReminderTime(state);
  const numberOfReminders = getNumberOfReminders(state);
  const reminderDays = getReminderDays(state);

  const now = moment();
  const currentWeek = now.week();

  const selectedDaysArray = Object.keys(reminderDays).filter(
    el => reminderDays[el],
  );

  if (!numberOfReminders || !selectedDaysArray.length) return;

  const { firstName } = state.user;
  const { steps = [] } = state.userCampaign?.campaignSelected;
  // const totalDoneThisWeek = 0;
  const actionNumber = steps.filter(el => el.done).length + 1;
  // week logic should start on Monday to be coherent

  // we schedule notifs of the month
  monthlyNotif({ firstName, notifTime: firstReminderTime });

  // we schedule selectedWeeks

  const firstNotifications = getFirstNotifications({ firstName, actionNumber });
  const lastNotifications = getLastNotifications({ firstName, actionNumber });

  selectedDaysArray.map(dayNumber => {
    // First Week
    // firstNotifTime
    const day = parseInt(dayNumber, 10);

    // Be sure to alternate the weeks
    const dayIndex = currentWeek % 2 ? day - 1 : day + 6;
    const secondWeekIndex = currentWeek % 2 ? dayIndex + 7 : dayIndex - 7;
    // const dayIndex = day - 1;
    // const secondWeekIndex = dayIndex + 7;

    const firstDate = setNotifTimeValue({
      notifTime: firstReminderTime,
      isoWeekDay: day,
      week: 0,
    });

    if (now.isBefore(firstDate)) {
      scheduleNotif({
        date: firstDate,
        notificationId: parseInt(`11${day}`),
        title: firstNotifications[dayIndex].title,
        body: firstNotifications[dayIndex].body,
      });
    }

    if (numberOfReminders > 1) {
      const secondDate = setNotifTimeValue({
        notifTime: secondReminderTime,
        isoWeekDay: day,
        week: 0,
      });

      if (now.isBefore(secondDate) && numberOfReminders > 1) {
        // secondReminderTime
        scheduleNotif({
          date: secondDate,
          notificationId: parseInt(`12${day}`),
          title: lastNotifications[dayIndex].title,
          body: lastNotifications[dayIndex].body,
        });
      }

      if (numberOfReminders > 2) {
        const randomNotifications = getRandomNotifications({ firstName });

        // const randomMinute = getRandomIntInclusive(0, 59);
        const thirdDate = setNotifTimeValue({
          notifTime: thirdReminderTime,
          isoWeekDay: day,
        });

        if (now.isBefore(thirdDate)) {
          const randomIndex = getRandomIntInclusive(0, 19);
          scheduleNotif({
            date: thirdDate,
            notificationId: parseInt(`13${day}`),
            title: randomNotifications[randomIndex].title,
            body: randomNotifications[randomIndex].body,
          });
        }

        const randomIndex2 = getRandomIntInclusive(0, 19);

        const thirdDate2 = setNotifTimeValue({
          notifTime: thirdReminderTime,
          isoWeekDay: day,
          week: 1,
        });

        scheduleNotif({
          date: thirdDate2,
          notificationId: parseInt(`23${day}`),
          title: randomNotifications[randomIndex2].title,
          body: randomNotifications[randomIndex2].body,
        });
      }
    }

    // Second Week

    const firstDate2 = setNotifTimeValue({
      notifTime: firstReminderTime,
      isoWeekDay: day,
      week: 1,
    });
    const secondDate2 = setNotifTimeValue({
      notifTime: secondReminderTime,
      isoWeekDay: day,
      week: 1,
    });

    // firstNotifTime
    scheduleNotif({
      date: firstDate2,
      notificationId: parseInt(`21${day}`),
      title: firstNotifications[secondWeekIndex].title,
      body: firstNotifications[secondWeekIndex].body,
    });

    // lastNotifTime
    if (numberOfReminders > 1) {
      scheduleNotif({
        date: secondDate2,
        notificationId: parseInt(`22${day}`),
        title: lastNotifications[secondWeekIndex].title,
        body: lastNotifications[secondWeekIndex].body,
      });
    }
  });
};

export const scheduleReminderNotif = async (reminderTime: {
  hour: number;
  minute: number;
}) => {
  const state = await store.getState();
  const { firstName } = state.user;
  const now = moment();

  const currentWeekday = moment().isoWeekday();
  const notifDate = moment()
    .isoWeekday(currentWeekday)
    .hour(reminderTime.hour)
    .minute(reminderTime.minute)
    .second(0);

  // schedule for the next active day
  if (notifDate.isBefore(now)) {
    // we will be the weekend
    if (currentWeekday === 5) {
      notifDate.add(3, "day");
    } else {
      notifDate.add(1, "day");
    }
  }
  // starting from today
  scheduleNotif(
    {
      date: notifDate.toDate(),
      notificationId: currentWeekday, // id
      title: i18n.t("reminder-notif-title", { firstName }),
      body: i18n.t("reminder-notif-message"),
    },
    // "day"
  );
};

export const scheduleChallengeNotif = async (
  challengeReminder,
  actionTitle,
  challengeText,
) => {
  const now = moment();
  let currentWeekday = moment().isoWeekday();

  let notifDate: Moment;
  notifDate = moment()
    .isoWeekday(currentWeekday)
    .hour(challengeReminder?.hour)
    .minute(challengeReminder?.minute)
    .second(0);

  if (actionTitle === "") actionTitle = i18n.t("Action");

  if (currentWeekday === 6) {
    notifDate?.add(2, "day");
    currentWeekday = 1;
  } else if (currentWeekday === 7) {
    notifDate?.add(1, "day");
    currentWeekday = 1;
  }
  // schedule for the next active day
  if (notifDate?.isBefore(now)) {
    // we will be the weekend
    if (currentWeekday === 5) {
      notifDate?.add(3, "day");
      currentWeekday = 1;
    } else {
      notifDate?.add(1, "day");
      currentWeekday = currentWeekday + 1;
    }
  }
  let id;
  // starting from today
  // loop to add notif every day and for 2 weeks about the selected challenge
  for (let i = 0; i < 14; i++) {
    id = parseInt(`${i}`);

    if (i === 3) {
      scheduleNotif({
        date: notifDate?.toDate(),
        notificationId: parseInt(`78${id}`),
        title: i18n.t("notif-change-challenge-title"),
        body: i18n.t("notif-change-challenge-body"),
      });
    } else {
      scheduleNotif({
        date: notifDate?.toDate(),
        notificationId: parseInt(`78${id}`),
        title: i18n.t("challenge-reminder-title"),
        body:
          actionTitle +
          i18n.t("challenge-reminder-return-line") +
          challengeText,
      });
    }

    if (currentWeekday === 5) {
      notifDate?.add(3, "day");
      currentWeekday = 1;
      i = i + 2;
    } else {
      notifDate?.add(1, "day");
      currentWeekday = currentWeekday + 1;
    }
  }
};

export const cancelChallengeReminderNotif = async () => {
  // reminderNotif is the id for the reminder notif
  for (let i = 0; i < 14; i++) {
    PushNotification.cancelLocalNotification({ id: `78${i}` }); // Id number for challenge
  }
};

export const cancelReminderNotif = async () => {
  // reminderNotif is the id for the reminder notif
  let i = 1;
  while (i <= 5) {
    PushNotification.cancelLocalNotification({ id: `${i}` });
    i++;
  }
};

export const cancelAllNotifications = async () => {
  try {
    await PushNotification.setApplicationIconBadgeNumber(0);
    await PushNotification.cancelAllLocalNotifications();
    if (Platform.OS === "ios") {
      await PushNotificationIOS.removeAllPendingNotificationRequests();
    }
  } catch (e) {
    console.log(e);
  }
};
